import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PageDialogComponent } from '../page-dialog/page-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-security-alert',
	standalone: true,
	imports: [PageDialogComponent, MatButtonModule, MatIconModule],
	templateUrl: './security-alert.component.html',
	styleUrl: './security-alert.component.scss'
})
export class SecurityAlertComponent {

	constructor(public dialogRef: MatDialogRef<SecurityAlertComponent>) {
		
	}

	close(): void {
		this.dialogRef.close()
	}

}
